<template>
  <div v-loading.fullscreen.lock="examinationLoading">
    <div v-for="(item, index) in examQuestion" :key="index">
      <h3 align="center" style="font-size: 25px">{{ stuIdMessage.stuName }}的考试情况明细</h3>
      <n-table :bordered="true" :single-line="false">
        <tbody>
          <tr>
            <td>姓名</td>
            <td>性别</td>
            <td>联系方式</td>
            <td>身份证号</td>
            <td>总分</td>
          </tr>
          <tr>
            <td>{{ stuIdMessage.stuName }}</td>
            <td>{{ stuIdMessage.sex === 2 ? '女' : '男' }}</td>
            <td>{{ stuIdMessage.mobilePhone }}</td>
            <td>{{ stuIdMessage.idNumber }}</td>
            <td>{{ stuIdMessage.examScore }}</td>
          </tr>
        </tbody>
      </n-table>

      <div>
        <el-row style="margin-top: 30px" :gutter="24">
          <div style="height: 1600px">
            <div>
              <span style="font-size: 20px; margin-right: 10px">单选题</span>
              <el-button type="text" round>共{{ item.questionBankVOList[0].length }}题</el-button>
            </div>
            <el-col
              v-for="(itemD, indexD) of item.questionBankVOList[0]"
              :key="indexD"
              :span="6"
              style="height: 300px"
            >
              <p
                ><span>{{ indexD + 1 }}.&nbsp;&nbsp;&nbsp;</span><b>{{ itemD.name }}</b
                ><b style="font-size: 25px; color: red">{{ itemD.isTrue === 0 ? cuo : dui }}</b></p
              >
              <p v-for="(itemT, indexT) of itemD.questionAnswerVOList" :key="indexT"
                >{{ itemT.sort }}.&nbsp;&nbsp;&nbsp;<span>{{ itemT.answerContent }}</span></p
              >

              <p style="">正确答案是: {{ itemD.trueAnswer }} </p>
              <p style="">你选的答案是: {{ itemD.stuAnswer }} </p>
            </el-col>
          </div>

          <div style="height: 1700px">
            <div>
              <span style="font-size: 20px; margin-right: 10px">多选题</span>
              <el-button type="text" round>共{{ item.questionBankVOList[1].length }}题</el-button>
            </div>
            <el-col
              v-for="(itemDuo, indexDuo) of item.questionBankVOList[1]"
              :key="indexDuo"
              :span="6"
              style="height: 330px"
            >
              <p
                ><span>{{ indexDuo + 1 }}.&nbsp;&nbsp;&nbsp;</span><b>{{ itemDuo.name }}</b
                ><b style="font-size: 25px; color: red">{{
                  itemDuo.isTrue === 0 ? cuo : dui
                }}</b></p
              >
              <p v-for="(indexDuoT, index) of itemDuo.questionAnswerVOList" :key="index"
                >{{ indexDuoT.sort }}.&nbsp;&nbsp;&nbsp;<span>{{
                  indexDuoT.answerContent
                }}</span></p
              >

              <p style="">正确答案是: {{ itemDuo.trueAnswer }}</p>
              <p style="">你选的答案是: {{ itemDuo.stuAnswer }}</p>
            </el-col>
          </div>

          <div style="height: 1750px">
            <div>
              <span style="font-size: 20px; margin-right: 10px">判断题</span>
              <el-button type="text" round>共{{ item.questionBankVOList[2].length }}题</el-button>
            </div>
            <el-col
              v-for="(itemP, index) of item.questionBankVOList[2]"
              :key="index"
              :span="6"
              style="height: 300px"
            >
              <p
                ><span>{{ index + 1 }}</span
                ><b>{{ itemP.name }}</b
                ><b style="font-size: 25px; color: red">{{ itemP.isTrue === 0 ? cuo : dui }}</b></p
              >
              <p v-for="(itemPt, index) of itemP.questionAnswerVOList" :key="index"
                >{{ itemPt.sort }}.&nbsp;&nbsp;&nbsp;<span>{{ itemPt.answerContent }}</span></p
              >

              <p style="">正确答案是: {{ itemP.trueAnswer }} </p>
              <p style="">你选的答案是: {{ itemP.stuAnswer }} </p>
            </el-col>
          </div>

          <div style="" v-if="item.photoList.length != 0">
            <p style="width: 130px; margin: 0 auto">考试抓拍人脸照片</p>
            <el-col v-for="(item, index) of item.photoList" :key="index" :span="6">
              <el-image
                style="width: 100px; height: 100px"
                :src="item.photo"
                :fit="fit"
                :preview-src-list="[item.photo]"
              >
              </el-image>
            </el-col>
          </div>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { getStuInfoScore, stuExamRecordWithPhoto } from '@/api';
export default {
  props: {
    msgKS: {
      type: String,
    },
  },
  data() {
    return {
      fit: 'contain',
      dui: '√',
      cuo: '×',
      imgBaseUrl: 'https://qingjuck.oss-cn-shanghai.aliyuncs.com/',
      //  学员基本信息
      stuIdMessage: {},
      examinationLoading: false,
      examQuestion: [],
      photoList: [],
    };
  },
  methods: {
    initial() {
      this.examinationLoading = true;
      console.log('川菜');
      console.log(this.msgKS);
      // 考试试题
      stuExamRecordWithPhoto({ stuId: this.msgKS }).then(res => {
        if (res.success === true) {
          this.examinationLoading = false;
          if (res.data.length !== 0) {
            console.log(res.data);
            const data = res.data;
            this.examQuestion = data;
            this.photoList = data[0].photoList; // 考试抓拍人脸
            if (this.photoList.length !== 0) {
              for (let p = 0; p < this.photoList.length; p++) {
                this.photoList[p].photo =
                  this.imgBaseUrl +
                  this.photoList[p].photo +
                  '?x-oss-process=image/resize,m_fill,h_200,w_300';
              }
            }

            //
            for (let y = 0; y < this.examQuestion.length; y++) {
              if (
                this.examQuestion[y] !== '' &&
                this.examQuestion[y].questionBankVOList.length !== 0
              ) {
                //  单选题
                for (let i = 0; i < this.examQuestion[y].questionBankVOList[0].length; i++) {
                  // console.log(this.examQuestion[y].questionBankVOList[0][i].questionAnswerVOList)
                  for (
                    let k = 0;
                    k < this.examQuestion[y].questionBankVOList[0][i].questionAnswerVOList.length;
                    k++
                  ) {
                    // console.log(this.examQuestion[y].questionBankVOList[0][i].questionAnswerVOList[k].sort)
                    if (
                      this.examQuestion[y].questionBankVOList[0][i].questionAnswerVOList[k].sort ===
                      1
                    ) {
                      this.examQuestion[y].questionBankVOList[0][i].questionAnswerVOList[k].sort =
                        'A';
                    } else if (
                      this.examQuestion[y].questionBankVOList[0][i].questionAnswerVOList[k].sort ===
                      2
                    ) {
                      this.examQuestion[y].questionBankVOList[0][i].questionAnswerVOList[k].sort =
                        'B';
                    } else if (
                      this.examQuestion[y].questionBankVOList[0][i].questionAnswerVOList[k].sort ===
                      3
                    ) {
                      this.examQuestion[y].questionBankVOList[0][i].questionAnswerVOList[k].sort =
                        'C';
                    } else if (
                      this.examQuestion[y].questionBankVOList[0][i].questionAnswerVOList[k].sort ===
                      4
                    ) {
                      this.examQuestion[y].questionBankVOList[0][i].questionAnswerVOList[k].sort =
                        'D';
                    }
                  }
                }
                // 多选题
                for (let i = 0; i < this.examQuestion[y].questionBankVOList[1].length; i++) {
                  // console.log(this.examQuestion[y].questionBankVOList[0][i].questionAnswerVOList)
                  for (
                    let k = 0;
                    k < this.examQuestion[y].questionBankVOList[1][i].questionAnswerVOList.length;
                    k++
                  ) {
                    // console.log(this.examQuestion[y].questionBankVOList[0][i].questionAnswerVOList[k].sort)
                    if (
                      this.examQuestion[y].questionBankVOList[1][i].questionAnswerVOList[k].sort ===
                      1
                    ) {
                      this.examQuestion[y].questionBankVOList[1][i].questionAnswerVOList[k].sort =
                        'A';
                    } else if (
                      this.examQuestion[y].questionBankVOList[1][i].questionAnswerVOList[k].sort ===
                      2
                    ) {
                      this.examQuestion[y].questionBankVOList[1][i].questionAnswerVOList[k].sort =
                        'B';
                    } else if (
                      this.examQuestion[y].questionBankVOList[1][i].questionAnswerVOList[k].sort ===
                      3
                    ) {
                      this.examQuestion[y].questionBankVOList[1][i].questionAnswerVOList[k].sort =
                        'C';
                    } else if (
                      this.examQuestion[y].questionBankVOList[1][i].questionAnswerVOList[k].sort ===
                      4
                    ) {
                      this.examQuestion[y].questionBankVOList[1][i].questionAnswerVOList[k].sort =
                        'D';
                    }
                  }
                }
                // // 判断
                for (let i = 0; i < this.examQuestion[y].questionBankVOList[2].length; i++) {
                  // console.log(this.examQuestion[y].questionBankVOList[0][i].questionAnswerVOList)
                  for (
                    let k = 0;
                    k < this.examQuestion[y].questionBankVOList[2][i].questionAnswerVOList.length;
                    k++
                  ) {
                    // console.log(this.examQuestion[y].questionBankVOList[0][i].questionAnswerVOList[k].sort)
                    if (
                      this.examQuestion[y].questionBankVOList[2][i].questionAnswerVOList[k].sort ===
                      1
                    ) {
                      this.examQuestion[y].questionBankVOList[2][i].questionAnswerVOList[k].sort =
                        'A';
                    } else if (
                      this.examQuestion[y].questionBankVOList[2][i].questionAnswerVOList[k].sort ===
                      2
                    ) {
                      this.examQuestion[y].questionBankVOList[2][i].questionAnswerVOList[k].sort =
                        'B';
                    }
                  }
                }
                console.log(this.examQuestion);
              } else {
                this.$message({
                  type: 'error',
                  message: '该同学未参加考试',
                });
                this.examQuestion = [];
              }
            }
          } else {
            this.examQuestion = [];
            this.$message({
              type: 'info',
              message: '暂无数据',
            });
          }
        } else {
          this.examQuestion = [];
          this.$message({
            type: 'error',
            message: '该同学未参加考试',
          });
        }
      });
    },
  },
  mounted() {
    this.initial();
    //  学员基本信息
    getStuInfoScore({ stuId: this.msgKS }).then(res => {
      if (res.success === true) {
        // console.log(res.data[0]);
        this.stuIdMessage = res.data[0];
      } else {
        this.$message({
          type: 'error',
          message: res.msg,
        });
      }
    });
  },
};
</script>
